import { Handler, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    getSession as getSessionApi,
    updateSessionWithResult,
    UpdateSessionWithResultApiParameter,
} from "@insite/client-framework/Services/SessionService";
import { chain, NavigateToReturnUrl, UpdateSession } from "@insite/client-framework/Store/Context/Handlers/ChangeCustomerContext";
import { BillToModel, ShipToModel } from "@insite/client-framework/Types/ApiModels";
import { getRememberBillToShipTo } from "@store/Store/Context/ContextSelectors";
import StoreApplicationState from "@store/Store/StoreApplicationState";

/**
 * Since the chain will not force a reload of the page, the chain should get an updated session.
 */
replaceInChain(chain, UpdateSession, async props => {

    const newApiParameter: UpdateSessionWithResultApiParameter = { ...props.apiParameter };
    if (props.apiParameter.session.billToId) {
        newApiParameter.session.billTo = {
            id: props.parameter.billToId,
            isDefault: props.parameter.isDefault,
        } as BillToModel;
    }
    if (props.apiParameter.session.shipToId !== undefined) {
        newApiParameter.session.shipTo = { id: props.parameter.shipToId } as ShipToModel;
    }

    /* Poolcorp Custom Code */
    const rememberBillToShipTo = getRememberBillToShipTo(props.getState() as StoreApplicationState);
    
    if (!rememberBillToShipTo) {
        newApiParameter.session.properties = {
            "removeDefaultBillToShipTo": "true",
        };
    } else if (rememberBillToShipTo && props.apiParameter.session.billToId && props.apiParameter.session.shipToId !== undefined) {
        newApiParameter.session.properties = {
            'loginDefaultBillTo': props.apiParameter.session.billToId,
            'loginDefaultShipTo': props.apiParameter.session.shipToId,
        };
    }
    /* Poolcorp Custom Code */

    const result = await updateSessionWithResult(newApiParameter);
    if (result.successful) {
        props.apiResult = await getSessionApi({});
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
});

